import { render, staticRenderFns } from "./VMarkdown.vue?vue&type=template&id=1fb1071c&scoped=true"
import script from "./VMarkdown.vue?vue&type=script&lang=js"
export * from "./VMarkdown.vue?vue&type=script&lang=js"
import style0 from "./VMarkdown.vue?vue&type=style&index=0&id=1fb1071c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1071c",
  null
  
)

export default component.exports